import { render } from "./user-preferences.vue?vue&type=template&id=5250edc1"
import script from "./user-preferences.vue?vue&type=script&lang=js"
export * from "./user-preferences.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__